import React, { useState } from 'react';
import { Modal } from '../components/Modal';
import { ZoomIn } from 'lucide-react';
import { SEO } from '../components/SEO';
import { VideoGallery } from '../components/VideoGallery';

const galleryPhotos = [
  {
    url: "https://i.postimg.cc/bDbL4Ky3/Attachment.jpg",
    title: "Événement du Cercle Poincaré",
    description: "Rencontre et échanges entre les membres"
  },
  {
    url: "https://i.postimg.cc/H89zkX7M/Attachment-1.jpg",
    title: "Conférence",
    description: "Discussion sur les enjeux contemporains"
  },
  {
    url: "https://i.postimg.cc/HVtvYDQN/Attachment-1-1.jpg",
    title: "Table ronde",
    description: "Débat sur l'innovation et la recherche"
  },
  {
    url: "https://i.postimg.cc/dLJnSHzj/Attachment-10.jpg",
    title: "Réunion des membres",
    description: "Partage d'expériences et networking"
  },
  {
    url: "https://i.postimg.cc/D4T5hBmF/Attachment-3.jpg",
    title: "Présentation",
    description: "Intervention d'un expert invité"
  },
  {
    url: "https://i.postimg.cc/BjYhFT7c/Attachment-3-1.jpg",
    title: "Séminaire",
    description: "Formation et développement professionnel"
  },
  {
    url: "https://i.postimg.cc/Yh88cN7K/Attachment-4.jpg",
    title: "Conférence plénière",
    description: "Discussion sur les enjeux sociétaux"
  },
  {
    url: "https://i.postimg.cc/G45Qtc9X/Attachment-5.jpg",
    title: "Rencontre",
    description: "Échange d'idées et de perspectives"
  },
  {
    url: "https://i.postimg.cc/G4h797Km/Attachment-5-1.jpg",
    title: "Discussion",
    description: "Échange entre membres"
  },
  {
    url: "https://i.postimg.cc/d7g4HqYh/Attachment-7.jpg",
    title: "Présentation",
    description: "Partage de connaissances"
  },
  {
    url: "https://i.postimg.cc/PCxydLfL/Attachment-8.jpg",
    title: "Réunion",
    description: "Échange et networking"
  },
  {
    url: "https://i.postimg.cc/Rq7Xd5b0/Attachment-9.jpg",
    title: "Conférence",
    description: "Partage d'expertise"
  }
];

export const Gallery = () => {
  const [selectedPhoto, setSelectedPhoto] = useState<number | null>(null);

  return (
    <>
      <SEO title="Galerie" />
      <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Galerie
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Revivez les moments forts du Cercle Poincaré à travers notre collection de photos et vidéos
            </p>
          </div>

          {/* Videos Section */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold text-gray-900 mb-8">Vidéos</h2>
            <VideoGallery />
          </section>

          {/* Photos Section */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-8">Photos</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {galleryPhotos.map((photo, index) => (
                <div
                  key={index}
                  className="relative aspect-[4/3] group cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300"
                  onClick={() => setSelectedPhoto(index)}
                >
                  <img
                    src={photo.url}
                    alt={photo.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300 flex items-center justify-center">
                    <ZoomIn className="text-white h-10 w-10" />
                    <div className="absolute bottom-0 left-0 right-0 p-4">
                      <h3 className="text-white text-lg font-semibold">{photo.title}</h3>
                      <p className="text-white/80 text-sm">{photo.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Photo Modal */}
          <Modal
            isOpen={selectedPhoto !== null}
            onClose={() => setSelectedPhoto(null)}
          >
            {selectedPhoto !== null && (
              <div className="p-4">
                <img
                  src={galleryPhotos[selectedPhoto].url}
                  alt={galleryPhotos[selectedPhoto].title}
                  className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
                />
                <div className="mt-4">
                  <h3 className="text-xl font-bold text-gray-900">
                    {galleryPhotos[selectedPhoto].title}
                  </h3>
                  <p className="mt-2 text-gray-600">
                    {galleryPhotos[selectedPhoto].description}
                  </p>
                </div>
              </div>
            )}
          </Modal>
        </div>
      </div>
    </>
  );
};